import React from 'react'
import {ParallaxPart} from "./ParallaxPart"
import {Safety} from './Safety'
import {Footer} from '../../Footer/Footer';
import { ResponsiveFooter } from '../../Footer/ResponsiveFooter';
import styled from 'styled-components';
import { Copyright } from '../../Copyright/Copyright';
import {Appointment} from './Appointment';
// import { Consult } from './Consult';
import  {DownloadPracto} from './DownloadPracto';

const FooterNonResponsive=styled.div`
@media all and (max-width: 769px)
{
    display: none;
}
`
const FooterResponsive=styled.div`
display:none;
@media all and (max-width: 769px)
{
    display: flex;
    flex-direction: column;
}
`
export const Doctors = () => {
  return (
    <>
    <ParallaxPart/>   
    <Safety/> 
    <Appointment/>
    {/* <Consult/> */}
    <DownloadPracto/>
    <FooterNonResponsive>
      <Footer/>
    </FooterNonResponsive>
    <FooterResponsive>
      <ResponsiveFooter mainTitle="Practo" subHeading={["About","Blog","Careers","Press","Contact Us"]}/>
      <ResponsiveFooter mainTitle="For Patients" subHeading={["Search for Clinics","Search for Hospitals","Search for Doctors","Book Diagnostics Tests","Book Full Body Checkups","Practo Plus","Covid Hospital listing","Health app","Practo Drive"]}/>
      <ResponsiveFooter mainTitle="For Doctors" subHeading={["Practo Consult","Health Feed","Practo Profile"]}/>
      <ResponsiveFooter mainTitle="For Clinics" subHeading={["Ray by Practo","Practo Reach","Ray Tab","Practo Pro"]}/>
      <ResponsiveFooter mainTitle="For Hospitals" subHeading={["Insta by Practo","Qikell by Practo","Practo Profile","Practo Reach"]}/>
      <ResponsiveFooter mainTitle="More" subHeading={["Help","Developers","Privacy Policy","Terms and Conditions","Health Directory","Corporate Wellness"]}/>
      <ResponsiveFooter mainTitle="Social" subHeading={["Facebook","Twitter","Linkedin","Youtube","Github"]}/>
      <Copyright/>
    </FooterResponsive>
    </>
  )
}
